export default __webpack_public_path__ + "static/media/trackButton-done.3b2ec0ad.svg";